// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K1Fw","newExpiryDate":"styles_newExpiryDate__TG1zZ","footer":"styles_footer__2vic3"};